import type { SubmissionLine } from '../api/types'

/** Lots whose CofA check failed (server kind 'missing_cofa'). Any entry means
 *  the submission cannot be approved, not even as an SPI decision. */
export function missingCofaLots(lines: SubmissionLine[] | undefined): string[] {
  const lots: string[] = []
  for (const ln of lines ?? []) {
    const failed = (ln.validation_results ?? []).some((r) => !r.passed && r.kind === 'missing_cofa')
    if (failed && !lots.includes(ln.lot_serial)) lots.push(ln.lot_serial)
  }
  return lots
}
